import React from "react";
import { Card, Col, Form, FormGroup, Input, Label } from "reactstrap";
import { useSelector } from "react-redux";
import { removeAccentsAndUppercase } from "../../../util/masks";
import * as operacaoController from "../../../controllers/operacaoRcController";
import * as operacaoActions from "../../../store/modules/operacaoRibercred/actions";

const Register = () => {

    const { item, copy, invalid, seeRegister } = useSelector(state => state.operacaoRibercred);

    function handleKeyPress(event) {
        if (event.key === "Enter") {
            event.preventDefault();
            if (item.id === "") {
                operacaoController.create(item);
            } else {
                operacaoController.update(item, copy);
            }
        }
    }

    function onChangeItem(value, field) {
        operacaoActions.cleanInvalid(field);
        operacaoActions.item({ ...item, [field]: value });
    }

    return (
        <>
            <Col>
                <Card className="radius pb-5">
                    <Col className="pt-2" style={{ margin: '25px 0 0 25px' }}>
                        <p style={{ fontSize: "18px", color: 'var(--color-preto)' }}>
                            Preencha os campos para cadastrar uma nova Operação Ribercred
                        </p>
                    </Col>
                    <Form>
                        <Col style={{ margin: '25px 0 0 25px' }}>
                            <FormGroup>
                                <Label for="operation" style={{ fontWeight: '700', color: 'var(--color-preto)' }}>Descrição da Operação Ribercred</Label>
                                <Input
                                    type="text"
                                    name="product"
                                    id="operation"
                                    placeholder="Digite aqui..."
                                    value={item.descricao}
                                    onChange={e => onChangeItem(removeAccentsAndUppercase(e.target.value), "descricao")}
                                    className={invalid.descricao ? "is-invalid" : ""}
                                    onKeyPress={e => handleKeyPress(e)}
                                    disabled={seeRegister ? true : false}
                                    style={{ width: '30%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Form>
                </Card>
            </Col>
        </>
    );
}

export default Register;